/** @format */

import { ReconciliationComponent } from "../Module/Users/paye/reconciliation/reconciliation.component";
// Privileges Enum

export enum Privileges {
	ADMIN = "ADMIN",
	MDA = "MDA",
	EXECUTIVE = "EXECUTIVE",

	MDA_EXECUTIVE = "MDA_EXECUTIVE",
	CAN_VIEW_TAXPAYER_PERFORMANCE = "CAN_VIEW_TAXPAYER_PERFORMANCE",
	CAN_VIEW_MDA_DASHBOARD = "CAN_VIEW_MDA_DASHBOARD",
	CAN_VIEW_GENERAL_DASHBOARD = "CAN_VIEW_GENERAL_DASHBOARD",
	CAN_VIEW_RECIEVEABLES = "CAN_VIEW_RECIEVEABLES",
	CAN_VIEW_REPORT_CENTER = "CAN_VIEW_REPORT_CENTER",
	CAN_SEARCH_TRANSACTION = "CAN_SEARCH_TRANSACTION",
	CAN_VIEW_REPORT_CENTER_LANDS = "CAN_VIEW_REPORT_CENTER_LANDS",
	CAN_VIEW_REPORT_CENTER_ANSAA = "CAN_VIEW_REPORT_CENTER_ANSAA",
	CAN_VIEW_REPORT_CENTER_APLUC = "CAN_VIEW_REPORT_CENTER_APLUC",
	CAN_VIEW_REPORT_CENTER_MOT = "CAN_VIEW_REPORT_CENTER_MOT",
	CAN_VIEW_REPORT_CENTER_IVAS = "CAN_VIEW_REPORT_CENTER_IVAS",
	CAN_VIEW_REPORT_CENTER_TAX = "CAN_VIEW_REPORT_CENTER_TAX",
	CAN_VIEW_REPORT_CENTER_EXCEPTION = "CAN_VIEW_REPORT_CENTER_EXCEPTION",
	CAN_VIEW_REPORT_CENTER_MINISTRY = "CAN_VIEW_REPORT_CENTER_MINISTRY",
	CAN_VIEW_REPORT_CENTER_AGENCY = "CAN_VIEW_REPORT_CENTER_AGENCY",
	CAN_VIEW_REPORT_CENTER_CULTURE = "CAN_VIEW_REPORT_CENTER_CULTURE",
	CAN_VIEW_ALL = "CAN_VIEW_ALL",

	SPLIT_ADMIN = "SPLIT_ADMIN",
	CAN_CREATE_ADMIN = "CAN_CREATE_ADMIN",
	CAN_UPDATE_ADMIN = "CAN_UPDATE_ADMIN",
	CAN_DELETE_ADMIN = "CAN_DELETE_ADMIN",
	CAN_READ_ADMIN = "CAN_READ_ADMIN",
	CAN_CREATE_ROLE = "CAN_CREATE_ROLE",
	COMPANY = "COMPANY",
	INDIVIDUAL = "INDIVIDUAL",

	CAN_CREATE_DIRECT_TAX = "CAN_CREATE_DIRECT_TAX",
	CAN_VIEW_DIRECT_TAX = "CAN_VIEW_DIRECT_TAX",
	CAN_APPROVE_DIRECT_TAX = "CAN_APPROVE_DIRECT_TAX",

	CAN_CREATE_HNI = "CAN_CREATE_HNI",
	CAN_VIEW_HNI = "CAN_VIEW_HNI",
	CAN_APPROVE_HNI = "CAN_APPROVE_HNI",

	CAN_CREATE_PRESUMPTIVE_TAX = "CAN_CREATE_PRESUMPTIVE_TAX",
	CAN_VIEW_PRESUMPTIVE_TAX = "CAN_VIEW_PRESUMPTIVE_TAX",
	CAN_APPROVE_PRESUMPTIVE_TAX = "CAN_APPROVE_PRESUMPTIVE_TAX",

	CAN_CREATE_ASWAMA = "CAN_CREATE_ASWAMA",
	CAN_VIEW_ASWAMA = "CAN_VIEW_ASWAMA",
	CAN_APPROVE_ASWAMA = "CAN_APPROVE_ASWAMA",

	CAN_CREATE_BUSINESS_PREMISES = "CAN_CREATE_BUSINESS_PREMISES",
	CAN_VIEW_BUSINESS_PREMISES = "CAN_VIEW_BUSINESS_PREMISES",
	CAN_APPROVE_BUSINESS_PREMISES = "CAN_APPROVE_BUSINESS_PREMISES",

	CAN_CREATE_FIRESERVICE = "CAN_CREATE_FIRESERVICE",
	CAN_VIEW_FIRESERVICE = "CAN_VIEW_FIRESERVICE",
	CAN_APPROVE_FIRESERVICE = "CAN_APPROVE_FIRESERVICE",

	CAN_CREATE_STAMP_DUTY = "CAN_CREATE_STAMP_DUTY",
	CAN_VIEW_STAMP_DUTY = "CAN_VIEW_STAMP_DUTY",
	CAN_APPROVE_STAMP_DUTY = "CAN_APPROVE_STAMP_DUTY",

	CAN_VIEW_PAYE = "CAN_VIEW_PAYE",
	CAN_VIEW_PAYE_TCC = "CAN_VIEW_TCC",
	CAN_CREATE_PAYE = "CAN_CREATE_PAYE",
	CAN_ASSESS_PAYE = "CAN_ASSESS_PAYE",
	PAYE_STAFF = "PAYE_STAFF",
	CAN_ASSIGN_AGENT = "CAN_ASSIGN_AGENT",
	CAN_TRACK_PAYE = "CAN_TRACK_PAYE",
	CAN_VIEW_ANNUAL_RETURNS = "CAN_VIEW_ANNUAL_RETURNS",
	CAN_VIEW_PAYE_REPORT = "CAN_VIEW_PAYE_REPORT",

	CAN_UPDATE_DIRECT_TAX = "CAN_UPDATE_DIRECT_TAX",
	CAN_CREATE_NON_TAX = "CAN_CREATE_NON_TAX",
	ALL_PERMISSIONS = "ALL_PERMISSIONS",

	CAN_VIEW_ALL_ASSESSMENTS = "CAN_VIEW_ALL_ASSESSMENTS",
	CAN_VIEW_ALL_NON_ASSESSMENTS = "CAN_VIEW_ALL_NON_ASSESSMENTS",
	CAN_APPROVE_ALL_ASSESSMENTS = "CAN_APPROVE_ALL_ASSESSMENTS",
	CAN_APPROVE_ALL_NON_ASSESSMENTS = "CAN_APPROVE_ALL_NON_ASSESSMENTS",
	CAN_CREATE_ALL_ASSESSMENTS = "CAN_CREATE_ALL_ASSESSMENTS",
	CAN_CREATE_ALL_NON_ASSESSMENTS = "CAN_CREATE_ALL_NON_ASSESSMENTS",

	CAN_DELETE_DIRECT_TAX = "CAN_DELETE_DIRECT_TAX",
	CAN_DELETE_HNI = "CAN_DELETE_HNI",
	CAN_DELETE_BUSINESS_PREMISES = "CAN_DELETE_BUSINESS_PREMISES",
	CAN_DELETE_FIRESERVICE = "CAN_DELETE_FIRESERVICE",
	CAN_DELETE_ASWAMA = "CAN_DELETE_ASWAMA",

	CAN_DELETE_ALL_ASSESSMENTS = "CAN_DELETE_ALL_ASSESSMENTS",
	CAN_DELETE_ALL_NON_ASSESSMENTS = "CAN_DELETE_ALL_NON_ASSESSMENTS",
	CAN_PROFILE_TAXPAYER = "CAN_PROFILE_TAXPAYER",
	CAN_EDIT_TAXPAYER_PROFILE = "CAN_EDIT_TAXPAYER_PROFILE",
	CAN_WAVE_DIRECT_TAX = "CAN_WAVE_DIRECT_TAX",
	CAN_VIEW_REPORT = "CAN_VIEW_REPORT",
	CAN_WAVE_DT = "CAN_WAVE_DT",

	CAN_VIEW_ASSESSMENT_BILLS = "CAN_VIEW_ASSESSMENT_BILLS",
	CAN_VIEW_OTHER_TAXES = "CAN_VIEW_OTHER_TAXES",

	CAN_MANAGE_TAXPAYER = "CAN_MANAGE_TAXPAYER",
	CAN_SET_WORKFLOW = "CAN_SET_WORKFLOW",
	CAN_MANAGE_ROLES = "CAN_MANAGE_ROLES",
	CAN_RECYCLE_BIN = "CAN_RECYCLE_BIN",
	CAN_VIEW_CGT = "CAN_VIEW_CGT",
	CAN_CREATE_CGT = "CAN_CREATE_CGT",
	CAN_APPROVE_CGT = "CAN_APPROVE_CGT",
	CAN_DELETE_CGT = "CAN_DELETE_CGT",

	CAN_DELETE_STAMP_DUTY = "CAN_DELETE_STAMP_DUTY",

	CAN_CREATE_WHT = "CAN_CREATE_WHT",
	CAN_VIEW_WHT = "CAN_VIEW_WHT",
	CAN_APPROVE_WHT = "CAN_APPROVE_WHT",
	CAN_APPROVE_TCC = "CAN_APPROVE_TCC",
	CAN_VIEW_MDA = "CAN_VIEW_MDA",
	CAN_GENERATE_MDA_SERVICES = "CAN_GENERATE_MDA_SERVICES",
	CAN_SET_MDA_SERVICES = "CAN_SET_MDA_SERVICES",
	CAN_VIEW_COLLECTION_REPORT = "CAN_VIEW_COLLECTION_REPORT",
	CAN_VIEW_ASSESSMENT_REPORT = "CAN_VIEW_ASSESSMENT_REPORT",
	CAN_VIEW_COLLECTIONS_REPORT = "CAN_VIEW_COLLECTIONS_REPORT",
	CAN_VIEW_VISUALIZATION_REPORT = "CAN_VIEW_ASSESSMENTS_REPORT",
	CAN_VIEW_PAYE_ETCC = "CAN_VIEW_PAYE_ETCC",
	CAN_VIEW_PAYE_TCC_MANUAL = "CAN_VIEW_PAYE_TCC_MANUAL",
	CAN_EDIT_PRESUMPTIVE_TAX = "CAN_EDIT_PRESUMPTIVE_TAX",
	CAN_CREATE_PAYE_TCC_MANUAL = "CAN_CREATE_PAYE_TCC_MANUAL",
	CAN_CREATE_PAYE_TCC_AUTOMATIC = "CAN_CREATE_PAYE_TCC_AUTOMATIC",
	CAN_CREATE_PAYE_TCC = "CAN_CREATE_PAYE_TCC",

	CAN_VIEW_MONIE_REPORT = "CAN_VIEW_MONIE_REPORT",
	CAN_VIEW_MONIE_REPORT_TODAY = "CAN_VIEW_MONIE_REPORT_TODAY",
	CAN_VIEW_MONIE_REPORT_THIS_WEEK = "CAN_VIEW_MONIE_REPORT_THIS_WEEK",
	CAN_VIEW_MONIE_REPORT_THIS_MONTH = "CAN_VIEW_MONIE_REPORT_THIS_MONTH",
	CAN_VIEW_MONIE_REPORT_THIS_YEAR = "CAN_VIEW_MONIE_REPORT_THIS_YEAR",
	CAN_VIEW_MONIE_REPORT_EVERYTHING = "CAN_VIEW_MONIE_REPORT_EVERYTHING",

	CAN_VIEW_SUPPORT = "CAN_VIEW_SUPPORT",
	CAN_EDIT_PAYMENT_ASIN = "CAN_EDIT_PAYMENT_ASIN",
	CAN_EDIT_PAYMENT_REVENUE_CODE = "CAN_EDIT_PAYMENT_REVENUE_CODE",

	CAN_CHANGE_ADMIN_PASSWORD = "CAN_CHANGE_ADMIN_PASSWORD",
	CAN_VIEW_TAMA = "CAN_VIEW_TAMA",
	CAN_APPROVE_TAMA = "CAN_APPROVE_TAMA",
	CAN_VIEW_TAAS = "CAN_VIEW_TAAS",
	CAN_APPROVE_TAAS = "CAN_APPROVE_TAAS",
	CAN_VIEW_ZONAL_TARGET = "CAN_VIEW_ZONAL_TARGET",
	CAN_VIEW_MY_TARGET = "CAN_VIEW_MY_TARGET",
	CAN_VIEW_TARGET = "CAN_VIEW_TARGET",
	CAN_VIEW_STATION_TARGET = "CAN_VIEW_STATION_TARGET",

	CAN_CHANGE_USER_EMAIL = "CAN_CHANGE_USER_EMAIL",
	CAN_VIEW_ENUMERATION = "CAN_VIEW_ENUMERATION",

	CAN_MERGE_ASIN = "CAN_MERGE_ASIN",
	CAN_CREATE_SINGLE_INVOICE = "CAN_CREATE_SINGLE_INVOICE",
	CAN_APPROVE_SINGLE_INVOICE = "CAN_APPROVE_SINGLE_INVOICE",
	CAN_VIEW_SINGLE_INVOICE = "CAN_VIEW_SINGLE_INVOICE",
	CAN_EDIT_SINGLE_INVOICE = "CAN_EDIT_SINGLE_INVOICE",
	CAN_VIEW_SHOPS = "CAN_VIEW_SHOPS",

	CAN_GENERATE_MANUAL_CGT_DEMAND_NOTICE = "CAN_GENERATE_MANUAL_CGT_DEMAND_NOTICE",
	CAN_VIEW_ASIN_REPORT = "CAN_VIEW_ASIN_REPORT",
	"NIN_BYPASS" = "NIN_BYPASS",

	ALL_MDA_PERMISSIONS = "ALL_MDA_PERMISSIONS",

	CAN_CHANGE_ASIN_TYPE = "CAN_CHANGE_ASIN_TYPE",

	CAN_INCREASE_NON_TAX_ASSESSMENT = "CAN_INCREASE_NON_TAX_ASSESSMENT",
	CAN_RECONCILE_ADDITIONAL_ASSESSMENT = "CAN_RECONCILE_ADDITIONAL_ASSESSMENT",
	CAN_REDUCE_ASSESSMENT = "CAN_REDUCE_ASSESSMENT",
	CAN_GENERATE_WAIVER = "CAN_GENERATE_WAIVER",

	CAN_VIEW_GENERAL_REPORT = "CAN_VIEW_GENERAL_REPORT",
	CAN_VIEW_EXCEPTION_REPORT = "CAN_VIEW_EXCEPTION_REPORT",
	CAN_VIEW_DETAILED_REPORT = "CAN_VIEW_DETAILED_REPORT",
	CAN_VIEW_TAXPAYER_SUMMERY_REPORT = "CAN_VIEW_TAXPAYER_SUMMERY_REPORT",
	CAN_SEARCH_TRANSACTION_REPORT = "CAN_SEARCH_TRANSACTION_REPORT",
	CAN_VIEW_EDL = "CAN_VIEW_EDL",
	CAN_VIEW_BOJ = "CAN_VIEW_BOJ",
	CAN_EDIT_DIRECT_TAX = "CAN_EDIT_DIRECT_TAX",
	CAN_EDIT_ALL_ASSESSMENTS = "CAN_EDIT_ALL_ASSESSMENTS",
	CAN_APPROVE_VAIDS_APPLICATION = "CAN_APPROVE_VAIDS_APPLICATION",
	CAN_ASSIGN_VAIDS_APPLICATION = "CAN_ASSIGN_VAIDS_APPLICATION",
	CAN_UNASSIGN_VAIDS_APPLICATION = "CAN_UNASSIGN_VAIDS_APPLICATION",
	CAN_VIEW_BACK_OFFICE = "CAN_VIEW_BACK_OFFICE",
	CAN_VIEW_ASIN_RECONCILIATION="CAN_VIEW_ASIN_RECONCILIATION",
	CAN_VIEW_SUPPORT_ADMIN = "CAN_VIEW_SUPPORT_ADMIN",
	ASIN_RECONCILIATION = "ASIN_RECONCILIATION",
	CAN_VIEW_PENALTY_ASSESSMENT = "CAN_VIEW_PENALTY_ASSESSMENT"

}

export enum WorkflowEnum {
	"DIRECT_TAX" = "DIRECT_TAX",
	"HNI" = "HNI",
	"BOJ_ASSESSMENT" = "BOJ_ASSESSMENT",
	"PRESUMPTIVE_TAX" = "PRESUMPTIVE_TAX",
	"PAYE" = "PAYE",
	"WITHHOLDING_TAX" = "WITHHOLDING_TAX",
	"ASWAMA" = "ASWAMA",
	"FIRE_SERVICE" = "FIRE_SERVICE",
	"BUSINESS_PREMISES" = "BUSINESS_PREMISES",
	"TCC" = "TCC",
	"CGT" = "CGT",
	"PAYE_TCC" = "PAYE_TCC",
	"SINGLE_INVOICE" = "SINGLE_INVOICE",
	"BACK_DUTY" = "BACK_DUTY",
	"TAMA" = "TAMA",
	"TAAS" = "TAAS",
	"VAIDS" = "VAIDS",
	"CONSOLIDATED_INVOICE" = "CONSOLIDATED_INVOICE",
	"PENALTY_ASSESSMENT" = "PENALTY_ASSESSMENT"
}

export enum MdaPrivileges {
	CAN_CREATE_MDA_ROLE = "CAN_CREATE_MDA_ROLE",
	ALL_MDA_PERMISSIONS = "ALL_MDA_PERMISSIONS",
	MDA = "MDA",
	CAN_VIEW_TAXPAYER = "CAN_VIEW_TAXPAYER",
	CAN_MANAGE_ROLES = "CAN_ROLE_ROLES",
	CAN_VIEW_CONFIGURATION = "CAN_VIEW_CONFIGURATION",
	CAN_MANAGE_USERS = "CAN_MANAGE_USERS",
	CAN_GENERATE_BILLS = "CAN_GENERATE_BILLS",
	CAN_VIEW_RECONCILIATION = "CAN_VIEW_RECONCILIATION",
	CAN_SET_SERVICES = "CAN_SET_SERVICES",
}
